export const GET_MY_REVIEWS_START = 'GET_MY_REVIEWS_START';

export const GET_MY_REVIEWS_SUCCESS = 'GET_MY_REVIEWS_SUCCESS';

export const GET_MY_REVIEWS_FAILED = 'GET_MY_REVIEWS_FAILED';
